/**
 * License store
 * @module store/license
 */

import { createStore, createHook } from '@thermon-platforms/react-sweet-state';
import api, { parseErrors } from 'util/api';


// define store initial state
const initialState = {
  expiration: undefined,
  error: undefined,
  updated: undefined
};
// define the actions that mutate the state
export const actions = {
  forceUpdate: () => ({setState}) => {
    setState({updated: Date.now()});
  },
  query: () => async ({ getState, setState }) => {
    const currentState = getState();
    // If we're already loading license info, return
    if (currentState.loading) return;
    // Set loading state
    setState({ loading: true });
    try {
      // Fetch our data
      const res = await api('/auth/license');
      const expiration = await res.json();

      setState({ expiration, loading: false, updated: Date.now() });
    } catch (error) {
      // If that fails, update our state with the error
      setState({ error, loading: false, updated: Date.now() });
    }
  }
}

// create a store type
const Store = createStore({ initialState, actions });

// create components to access store state instances
const useStore = createHook(Store);

/**
 * Expose hooks for store
 * @function useStore
 * @memberof module:store/license
 *
 * @example
 * const [licenseStore, licenseStoreActions] = useLicenseStore();
 *
 */
export default useStore;
